import React from "react";
import clsx from "clsx";
import OverviewHeader from "../components/OverviewHeader";
import RuleConditions from "./RuleConditions";
import Alert from "components/Alert";
import { useTranslation } from "react-i18next";
import { rulesSetStore } from "../RulesSetStore";
import { observer } from "mobx-react-lite";

interface RuleOverviewProps {
  close: () => void;
}

const RuleOverview = (props: RuleOverviewProps) => {
  const { t } = useTranslation();
  const { currentRule } = rulesSetStore;
  const [showValidationError, setShowValidationError] =
    React.useState<boolean>();

  const currentSavedRule = rulesSetStore.rulesList.find(
    (item) => item.id === currentRule?.id
  );

  React.useEffect(() => {
    setShowValidationError(
      currentSavedRule?.validationError && !rulesSetStore.inProgressRuleID
    );
  }, [currentRule?.id, rulesSetStore.inProgressRuleID]);

  React.useEffect(() => {
    if (showValidationError) {
      const timeout = setTimeout(() => {
        setShowValidationError(currentSavedRule?.validationError);
      }, 500);

      return () => clearTimeout(timeout);
    }
  }, [currentSavedRule?.validationError]);

  return (
    <div className={clsx("col-span-1 h-full overflow-y-auto flex flex-col")}>
      <OverviewHeader
        close={props.close}
        title={currentSavedRule?.name ?? currentRule?.name}
      />
      {showValidationError && (
        <Alert
          type="attention"
          title={t("rulesEditor.incompleteRulesTitle")}
          description={t("rulesEditor.incompleteRulesDescription")}
          className="mt-6 mx-6 -mb-3"
        />
      )}
      <RuleConditions />
      <Alert
        type="info"
        description={t("rulesEditor.informationAlert")}
        className="bg-transparent p-6 border-none"
      />
    </div>
  );
};

export default observer(RuleOverview);
